import React, { useState } from 'react'
import Modal from '../../Modal'
import { ClipBoard, Check, SmartPhone, WhatsApp, Phone } from '../../../assets/icons'
import theme from '../../../styled/theme'
import useIsMobile from '../../../hooks/useIsMobile'
import { Text1Bold, Title } from '../text'
import { ModalBody, ContactList, Description, BulletList, ContactButton } from './styled'
import { handleContactAction } from '../../../utils/contactActions'

const CONTACT_ICONS = {
  whatsapp: WhatsApp,
  phone: Phone,
}

const COPIED_RESET_MS = 1500

const ContactModal = ({
  title,
  description,
  bullets = [],
  note,
  contacts = [],
  onClose,
  widthDesktop = '639px',
}) => {
  const [copiedIndex, setCopiedIndex] = useState(-1)
  const isMobile = useIsMobile()

  const handleContactClick = (contact, index) => {
    const copied = handleContactAction(contact)
    if (copied) {
      setCopiedIndex(index)
      setTimeout(() => setCopiedIndex(-1), COPIED_RESET_MS)
    }
  }

  return (
    <Modal
      onClose={onClose}
      widthDesktop={isMobile ? '100%' : widthDesktop}
      isFullHeight={isMobile}
    >
      <ModalBody isMobile={isMobile}>
        {title && <Title color={theme.colors.text.primaryText} size="24px">{title}</Title>}
        {description && (
          <Description
            size="16px"
            lineHeight="24px"
            color={theme.colors.text.secondaryText}
          >
            {description}
          </Description>
        )}
        {bullets.length > 0 && (
          <BulletList
            size="16px"
            lineHeight="24px"
            color={theme.colors.text.secondaryText}
          >
            {bullets.map(bullet => (
              <li key={bullet}>{bullet}</li>
            ))}
          </BulletList>
        )}
        {note && (
          <Description
            size="16px"
            lineHeight="24px"
            color={theme.colors.text.secondaryText}
          >
            {note}
          </Description>
        )}
        <ContactList isMobile={isMobile}>
          {contacts.map((contact, index) => {
            const Icon = CONTACT_ICONS[contact.type] || SmartPhone
            const isCopied = copiedIndex === index
            return (
              <ContactButton
                key={contact.value}
                type="button"
                label={contact.value}
                $variant="secondary"
                iconLeft={<Icon size={20} color={theme.colors.brand.blueOmint} />}
                iconRight={
                  contact.type === 'phone' ? (
                    isCopied ? (
                      <Check size={20} color={theme.colors.brand.blueOmint} />
                    ) : (
                      <ClipBoard size={20} color={theme.colors.brand.blueOmint} />
                    )
                  ) : null
                }
                onClick={() => handleContactClick(contact, index)}
                style={{
                  justifyContent: 'flex-start',
                  width: '100%',
                  maxWidth: isMobile ? '100%' : '264px',
                }}
              />
            )
          })}
        </ContactList>
      </ModalBody>
    </Modal>
  )
}

export default ContactModal
